import { createApp } from '@app/adapters/create-app'
import AiOcrDocumentsUploader from '@app/application/ai_ocr_requests/components/ai-ocr-documents-uploader.vue'

export default (): void => {
  window.onDomLoad(($dom) => {
    const doc = $dom[0]

    const element = doc.querySelector(
      "[data-behaviour='ai-ocr-documents-upload']"
    ) as HTMLElement

    if (element) {
      const { ledgerId, accountId, reconciliationTextId, type } =
        element.dataset ?? {}

      createApp(AiOcrDocumentsUploader, {
        ledgerId: ledgerId ? parseInt(ledgerId) : null,
        reconciliationTextId: reconciliationTextId
          ? parseInt(reconciliationTextId)
          : null,
        accountId: accountId ? parseInt(accountId) : null,
        aiProposal: type === 'sf-ai-proposal',
      }).mount(element)
    }
  })
}
